import React from "react";
import ReactDOM from "react-dom/client";
import Bootstrap from "./Bootstrap";
import "./styles.css";
import "./auth.css";
import "./phase3.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Bootstrap />
  </React.StrictMode>
);
